<template lang='pug'>
  i.svg-icon.svg-icon-hp
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill='#E36256' d='M85.925,23.121H50v54.038h35.925c7.002,0,12.679-5.794,12.679-12.941V36.062 C98.604,28.915,92.927,23.121,85.925,23.121z')
      path(fill='#11979D' d='M50,23.121H14.074c-7.001,0-12.679,5.794-12.679,12.941v28.155c0,7.147,5.677,12.941,12.679,12.941H50 V23.121z')
      path(fill='#FFFFFF' d='M22.506,36.437h8.802v9.968h9.619v-9.968h8.841v28.486h-8.841V53.4h-9.619v11.522h-8.802V36.437z')
      path(fill='#FFFFFF' d='M55.578,36.437h14.63c3.188,0,5.574,0.758,7.161,2.273s2.381,3.672,2.381,6.471 c0,2.875-0.865,5.124-2.595,6.743c-1.729,1.619-4.369,2.428-7.918,2.428h-4.819v10.571h-8.84V36.437z M64.418,48.581h2.157 c1.697,0,2.889-0.294,3.576-0.884c0.687-0.589,1.029-1.344,1.029-2.264c0-0.894-0.298-1.651-0.895-2.273 c-0.596-0.622-1.716-0.933-3.36-0.933h-2.508V48.581z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '',
    },
  },
};

</script>
